import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { api, errMsg } from "../lib/api";

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) return setError("Le password non coincidono");
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  const input = "h-12 bg-stone-900 border-stone-700 focus-visible:ring-amber-500";
  return (
    <div className="min-h-[calc(100vh-72px)] flex items-center px-5 sm:px-12 py-12">
      <div className="w-full max-w-md mx-auto rise">
        <h2 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight">Nuova password</h2>
        {done ? (
          <div className="mt-6 space-y-4">
            <p data-testid="reset-success" className="text-emerald-300">Password aggiornata! Ora puoi accedere con la nuova password.</p>
            <Link to="/login" data-testid="reset-go-login" className="inline-flex h-12 px-6 items-center rounded-full bg-[#E0533C] hover:bg-[#C8432D] font-semibold transition-colors">Vai all'accesso</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-5" data-testid="reset-form">
            <div className="space-y-1.5">
              <Label htmlFor="np">Nuova password</Label>
              <Input id="np" type="password" data-testid="reset-password-input" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className={input} />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="cp">Ripeti la password</Label>
              <Input id="cp" type="password" data-testid="reset-confirm-input" required minLength={6} value={confirm} onChange={(e) => setConfirm(e.target.value)} className={input} />
            </div>
            {!token && <p className="text-sm text-red-400">Link non valido: manca il codice di reimpostazione.</p>}
            {error && <p data-testid="reset-error" className="text-sm text-red-400">{error}</p>}
            <button data-testid="reset-submit-button" disabled={loading || !token} className="w-full h-12 rounded-full bg-[#E0533C] hover:bg-[#C8432D] font-semibold text-white transition-colors disabled:opacity-60 inline-flex items-center justify-center gap-2">
              {loading && <Loader2 className="h-4 w-4 animate-spin" />} Salva la nuova password
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
